import React from 'react';
import { ShieldCheck, ArrowRight, Building2, UserCircle } from 'lucide-react';

export const BRCView: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 md:py-16 animate-slideUp">
      <div className="bg-yellow-400 text-black font-black text-center py-3 md:py-4 rounded-xl md:rounded-2xl mb-4 md:mb-6 shadow-lg animate-pulse text-sm md:text-base">
        COMEINGGG SOOOON 😀, THIS SECTION IS UNDER MAINTAINANCE
      </div>
      <div className="text-center mb-10 md:mb-16">
        <div className="inline-flex items-center bg-orange-100 text-orange-700 px-3 md:px-4 py-1.5 md:py-2 rounded-full text-[10px] md:text-xs font-black uppercase tracking-widest mb-3 md:mb-4">
          Block Resource Centre
        </div>
        <h2 className="text-2xl md:text-5xl font-black text-gray-900 tracking-tight">BRC Resource Portal</h2>
        <p className="text-gray-500 mt-3 md:mt-4 text-sm md:text-lg max-w-2xl mx-auto font-medium">
          Access official BRC portals, login systems, and salary documentation formats for Bihar Teachers.
        </p>
      </div>

      <div className="flex justify-center max-w-5xl mx-auto">
        {/* BRC Login Card */}
        <div className="bg-white rounded-[2rem] md:rounded-[3rem] p-6 md:p-10 shadow-sm border border-gray-100 hover:shadow-2xl transition-all group overflow-hidden relative max-w-md w-full">
          <div className="absolute top-0 right-0 p-6 md:p-8 opacity-5 group-hover:scale-110 transition-transform">
            <ShieldCheck size={80} className="md:w-[120px] md:h-[120px] text-indigo-900" />
          </div>
          <div className="bg-indigo-50 w-16 h-16 md:w-20 md:h-20 rounded-2xl md:rounded-[2rem] flex items-center justify-center mb-6 md:mb-8 shadow-inner">
            <UserCircle size={32} className="md:w-10 md:h-10 text-indigo-600" />
          </div>
          <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-3 md:mb-4 tracking-tight">BRC LOGIN</h3>
          <p className="text-gray-500 mb-6 md:mb-8 leading-relaxed font-medium text-sm md:text-base">
            Access the official BRC administration portal for attendance, departmental updates, and reporting.
          </p>
          <button 
            className="w-full bg-indigo-600 text-white py-4 md:py-5 rounded-xl md:rounded-[2rem] font-black text-lg md:text-xl hover:bg-indigo-700 shadow-xl shadow-indigo-100 transition-all flex items-center justify-center group/btn"
          >
            Go to Login Portal
            <ArrowRight size={20} className="md:w-[22px] md:h-[22px] ml-2 md:ml-3 group-hover/btn:translate-x-2 transition-transform" />
          </button>
        </div>
      </div>

      <div className="mt-12 md:mt-20 bg-gray-900 rounded-[2.5rem] md:rounded-[4rem] p-8 md:p-12 text-center relative overflow-hidden">
        <div className="absolute top-0 right-0 p-8 md:p-12 opacity-10">
          <Building2 size={100} className="md:w-[150px] md:h-[150px] text-white" />
        </div>
        <div className="relative z-10">
          <h4 className="text-white text-xl md:text-2xl font-black mb-3 md:mb-4">Need help with BRC Portal?</h4>
          <p className="text-gray-400 mb-0 max-w-xl mx-auto text-sm md:text-base">
            If you are facing issues with your credentials or the arrear calculation, please contact your block's MIS coordinator.
          </p>
        </div>
      </div>
    </div>
  );
};